export default "__VITE_ASSET__Cx4XZah0__"